import SingleLineField from './SingleLineField';

export default SingleLineField;
